import { Component, OnInit, Injector, ViewChild, ViewEncapsulation, Injectable } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AdminActivitiesServiceProxy, AdminActivityDto } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';


@Component({
    templateUrl: './header-activities.component.html',
    selector: '[headerActivities]',
    encapsulation: ViewEncapsulation.None
})
@Injectable()
export class HeaderActivitiesComponent extends AppComponentBase implements OnInit {

    activities: AdminActivityDto[] = [];
    countItens: number = 0;

    constructor(
        injector: Injector,
        private _adminActivitiesServiceProxy: AdminActivitiesServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadActivities();
        this.registerToEvents();
    }

    registerToEvents() {
        abp.event.on('app.activities.refresh', () => {
            this.loadActivities();
        });
    }

    loadActivities(): void {

        let today = moment().startOf('day');
        let end = moment().endOf('year')
        this._adminActivitiesServiceProxy.getAll(
            undefined,
            undefined,
            today,
            end,
            undefined,
            this.appSession.user.id,
            undefined,
            0,
            10
        ).subscribe(result => {
            this.activities = [];
            for (let i = 0; i < result.items.length && i < 3; i++) {
                this.activities.push(result.items[i].adminActivity)
            }
            this.countItens = this.activities.length;
        });
    }

    gotoActivity(id: number) {
    
        let url = '/app/admin/adminActivities?activityId=' + id;
        let target = '_blank'
        window.open(url, target);
    }

    seeAll(){
        this.resetCount();
        let url = '/app/admin/adminActivities';
        let target = '_blank'
        window.open(url, target);
    }

    resetCount(){
        this.countItens = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/adminActivities/header-activities.component.ts